import { Dictionary } from "../type/dictionary";

/** 
 * ガジェットのマテリアルID（属性ID）
 * 注意事項：
 * ・一意の番号でなければならない。（重複したマテリアルIDをつけてはいけない。）
 * ・DBに保存されるので番号を変えてはいけない。
 */
export const MaterialId: Dictionary<string, number> = {
  DIMENSION_YEAR: 15,     // 年毎
  DIMENSION_MONTH: 16,    // 月毎
  DIMENSION_DATE: 17,     // 日毎
  DIMENSION_HOUR: 18,       // 時毎
  COMPARE_TARGET_MEMBER: 29,      // [比較対象] 個人
  COMPARE_TARGET_GROUP: 30,       // [比較対象] グループ
  COMPARE_TARGET_COMPANY: 31,     // [比較対象] 全社
  COMPARE_TARGET_ALL: 32,         // [比較対象] 全国
  DIMENSION_DAYS_HOUR: 44,  // 時毎。24H超えあり。
  DIMENSION_36_MONTH: 47,   // 起算日から月毎
  MEASURE_OP_COUNT_HEATMAP: 62,  // 操作回数ヒートマップ用の操作回数算出。
  DIMENSION_DAY_OF_WEEK: 63,   // 曜日毎
  COMPARE_TARGET_DEPARTMENT: 55,  // [比較対象] 部署
} as const;
